import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import g1 from '../assets/gallery/g1.webp';
import g2 from '../assets/gallery/g2.webp';
import g3 from '../assets/gallery/g3.webp';
import g4 from '../assets/gallery/g4.webp';
import g5 from '../assets/gallery/g5.webp';
import g6 from '../assets/gallery/g6.webp';
import g7 from '../assets/gallery/g7.webp';
import './Gallery.css';

const Gallery = () => {
  useEffect(() => {
    document.title = 'Celebrity Cuts Hair & Beauty Gallery';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Explore the Celebrity Cuts Hair & Beauty Gallery to see our professional styling, hair transformations, and beauty services delivered by expert stylists in Visakhapatnam.');
  }, []);
  const galleryImages = [
    { id: 1, image: g1, title: ' ' },
    { id: 2, image: g2, title: ' ' },
    { id: 3, image: g3, title: ' ' }, { id: 4, image: g4, title: ' ' },
    { id: 5, image: g5, title: ' ' },
    { id: 6, image: g6, title: ' ' },
    { id: 7, image: g7, title: ' ' }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <section className="gallery-page">
      <div className="container">
        <motion.div
          className="gallery-header"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="gallery-title">Celebrity Cuts Hair &amp; Beauty Gallery</h1>
          <div className="gallery-divider"></div>
          <p className="gallery-subtitle">Explore our finest work and transformations</p>
        </motion.div>

        <motion.div
          className="gallery-grid"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {galleryImages.map((item) => (
            <motion.div
              key={item.id}
              className="gallery-item"
              variants={itemVariants}
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              <div className="gallery-image-container">
                <img
                  src={item.image}
                  alt={item.title}
                  className="gallery-image"
                  loading="lazy"
                />
                <div className="gallery-overlay">
                  <h3 className="gallery-item-title">{item.title}</h3>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Gallery;
